import { createApp } from 'vue';
import { configureCompat } from 'vue'
import * as bootstrap from 'bootstrap';
import getBugsnagClient from './bugsnag';
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css'
import 'sweetalert2/src/sweetalert2.scss';

import Vue3FormWizard from 'vue3-form-wizard';
import 'vue3-form-wizard/dist/style.css';

window.bootstrap = bootstrap;
import 'bootstrap5-toggle/js/bootstrap5-toggle.jquery.min.js';
import AlternativeAddress from './components/start/AlternativeAddress.vue';
import ButtonCustomerLoginToggle from './components/start/ButtonCustomerLoginToggle.vue';
import ButtonDeleteHard from './components/start/ButtonDeleteHard.vue';
import ButtonSyncCustomerToPMS from './components/start/ButtonSyncCustomerToPMS.vue';
import ButtonRenewMandate from './components/start/ButtonRenewMandate.vue';
import ContactPersonInfo from './components/start/ContactPersonInfo.vue';
import InvoiceTable from './components/start/InvoiceTable.vue';
import MobilityKey from './components/start/MobilityKey.vue';
import PaymentInfo from './components/start/PaymentInfo.vue';
import TeilnehmerData from './components/start/TeilnehmerData.vue';
import UserData from './components/start/UserData.vue';
import AdminUserSettings from './components/start/AdminUserSettings.vue';

import MobilityKeyRequestList from './components/MobilityKeyRequestList.vue'

import ButtonAbrechnungExtended from './components/ButtonAbrechnungExtended.vue';
import ParkobjectList from './components/ParkobjectList.vue';
import ParkobjectTarifAdd from './components/ParkobjectTarifAdd.vue';
import ParkobjectTarifList from './components/ParkobjectTarifList.vue';
import SuspendedUsers from './components/SuspendedUsers.vue';
import SuspendedUsersAdd from './components/SuspendedUsersAdd.vue';
import UpdateComponent from './components/UpdateComponent.vue';
import UsersList from './components/UsersList.vue';
import UsersAdd from './components/UsersAdd.vue';
import WaitingList from './components/WaitingList.vue';
import WaitingListAdd from './components/WaitingListAdd.vue';
import AuthMediaList from './components/AuthMediaList.vue';
import AuthMediaAdd from './components/AuthMediaAdd.vue';
import KundenantragList from './components/KundenantragList.vue';
import KundenantragTeilnehmerCreate from './components/KundenantragTeilnehmerCreate.vue';
import LogsList from './components/LogsList.vue';
import CustomerTarifChangeList from './components/CustomerTarifChangeList.vue';

import PasswordReset from './components/PasswordReset.vue';
import LoadingAnimation from './components/LoadingAnimation.vue';

import TeilnehmerList from './components/TeilnehmerList.vue';
import TeilnehmerEdit from './components/TeilnehmerEdit.vue';
import TeilnehmerCopy from './components/TeilnehmerCopy.vue';
import TarifSelect from './components/TarifSelect.vue';

import TeilnehmerAdd from './components/TeilnehmerAdd.vue';
import FirmennachzahlerAdd from './components/FirmennachzahlerAdd.vue';
import RechnungsempfaengerAdd from './components/RechnungsempfaengerAdd.vue';



import * as Klaro from 'klaro';

const config = {
    storageMethod: 'cookie',
    storageName: 'meine.apag.de',
    default: false,
    acceptAll: true,
    mustConsent: true,
    lang: 'de',
    translations: {
        privacyPolicyUrl: 'https://apag.de/datenschutz',
        de: {
            consentModal: {
                title: "Cookies auf meine.apag.de",
            },
            notwendig: {
                title: "Notwendig",
                description: "Notwendige Cookies helfen dabei, eine Webseite nutzbar zu machen, indem sie Grundfunktionen wie Seitennavigation und Zugriff auf sichere Bereiche der Webseite ermöglichen. Die Webseite kann ohne diese Cookies nicht richtig funktionieren."
            },
            googleMaps: {
                title: "Google Maps",
                description: "Der Dienst Google Maps ermöglicht uns die Darstellung von Standorten auf einer interaktiven Karte. Da bei der Einbindung Daten an Google übertragen werden, müssen Sie der Verwendung zuvor zustimmen. Deaktivieren Sie diesen Dienst, um die Einbindung von Google Maps zu untersagen. Es gilt die Google-Datenschutzerklärung.",
            },
            bugsnag: {
                title: "Bugsnag",
                description: "Bugsnag ist ein Dienst, mit dem Programmfehler, bspw. Abstürze der von uns angebotenen Dienste, an uns gemeldet und von uns analysiert werden können. Diese Daten werden auf den Servern von Bugsnag (USA) gespeichert."
            },
            purposes: {
                maps: "Kartenansicht",
                notwendig: "Funktionalität",
                error: "Fehleranalyse"
            }
        }
    },
    services: [
        {
            name: "notwendig",
            purposes: ["notwendig"],
            required: true,
        },
        {
            name: "googleMaps",
            purposes: ["maps"],
        },
        {
            name: "bugsnag",
            purposes: ["error"],
        },
    ]
};
window.klaro = Klaro;
window.config = config;
let consentManager = klaro.getManager(config);
if (!consentManager.confirmed) {
    Klaro.show(config, true);
}

configureCompat({
    MODE: 3
});
// Vue 3 part?

const app = createApp({});
app.config.compilerOptions.whitespace = 'preserve';
// import VueFormGenerator from 'vue-form-generator';
// app.use(VueFormGenerator);

// import VueObserveVisibility from 'vue-observe-visibility'
// app.use(VueObserveVisibility)
const confirmed = consentManager.getConsent('bugsnag');
if(confirmed) {
    const bugsnagClient = getBugsnagClient();
    app.use(bugsnagClient.getPlugin('vue'));
}
consentManager.watch({
    update(obj, name, data) {
        if(obj.states.bugsnag) {
            const bugsnagClient = getBugsnagClient();
            app.use(bugsnagClient.getPlugin('vue'));
        }
    }
})

app.use(FloatingVue);
app.use(Vue3FormWizard);

app.component('AlternativeAddress', AlternativeAddress);
app.component('ButtonCustomerLoginToggle', ButtonCustomerLoginToggle);
app.component('ButtonDeleteHard', ButtonDeleteHard);
app.component('ButtonSyncCustomerToPMS', ButtonSyncCustomerToPMS);
app.component('ButtonRenewMandate', ButtonRenewMandate);
app.component('ContactPersonInfo', ContactPersonInfo);
app.component('InvoiceTable', InvoiceTable);
app.component('MobilityKey', MobilityKey);
app.component('PaymentInfo', PaymentInfo);
app.component('TeilnehmerData', TeilnehmerData);
app.component('UserData', UserData);
app.component('AdminUserSettings', AdminUserSettings);

app.component('SuspendedUsers', SuspendedUsers);
app.component('SuspendedUsersAdd', SuspendedUsersAdd);
app.component('UsersList', UsersList);
app.component('UsersAdd', UsersAdd);

app.component('MobilityKeyRequestList', MobilityKeyRequestList);

app.component('ParkobjectList', ParkobjectList);
app.component('ParkobjectTarifList', ParkobjectTarifList);
app.component('ParkobjectTarifAdd', ParkobjectTarifAdd);

app.component('ButtonAbrechnungExtended', ButtonAbrechnungExtended);

app.component('UpdateComponent', UpdateComponent);
app.component('WaitingList', WaitingList);
app.component('WaitingListAdd', WaitingListAdd);
app.component('AuthMediaList', AuthMediaList);
app.component('AuthMediaAdd', AuthMediaAdd);
app.component('KundenantragList', KundenantragList);
app.component('KundenantragTeilnehmerCreate', KundenantragTeilnehmerCreate);
app.component('LogsList', LogsList);
app.component('CustomerTarifChangeList', CustomerTarifChangeList);

app.component('PasswordReset', PasswordReset);
app.component('LoadingAnimation', LoadingAnimation);

app.component('TeilnehmerList', TeilnehmerList);
app.component('TeilnehmerEdit', TeilnehmerEdit);
app.component('TeilnehmerCopy', TeilnehmerCopy);
app.component('TarifSelect', TarifSelect);

// import AntragComponent from './components/kundenantrag/AntragComponent.vue';
// app.component('AntragComponent', AntragComponent);

app.component('TeilnehmerAdd', TeilnehmerAdd);
app.component('FirmennachzahlerAdd', FirmennachzahlerAdd);
app.component('RechnungsempfaengerAdd', RechnungsempfaengerAdd);

app.mount('#app');
